import React from 'react';
import Select from '../../layout/forms/Select';

const options = [
    { value: '1000', text: '1000' },
    { value: '10000', text: '10000' },
    { value: '50000', text: '50000' },
    { value: '100000', text: '100000' },
    { value: '1000000', text: '1000000'}
]
const MaxHits = ({ state, setState }) => {
    const onChange = (event) => {
        setState({
            ...state,
            maxHits: parseInt(event.target.value)
        })
    }
    return(
        <Select
            onChange={onChange}
            options={options}
            value={state.maxHits}                        
            label="Max hits"
            keyBase="Max-Hits"
        />
    )
}
export default MaxHits
